import SimpleDataWithVariation from '@/language/es/components/cards/models/SimpleDataWithVariation';
import CardWithTitle from '@/language/es/components/cards/models/CardWithTitle';
import PieChart from '@/language/es/components/cards/models/PieChart';
import TogglePieChart from '@/language/es/components/cards/models/TogglePieChart';
import BubbleChart from '@/language/es/components/cards/models/BubbleChart';
import CardChart from '@/language/es/components/cards/models/CardChart';
import InputController from '@/language/es/components/cards/models/InputController';
import LineChart from '@/language/es/components/cards/models/LineChart';
import TermGraph from '@/language/es/components/cards/models/TermGraph';
import Feed from '@/language/es/components/cards/models/Feed';
import CustomLineChart from '@/language/es/components/cards/models/CustomLineChart';
import CardOptions from '@/language/es/components/cards/models/CardOptions';

export default {
  SimpleDataWithVariation,
  CardWithTitle,
  PieChart,
  TogglePieChart,
  BubbleChart,
  CardChart,
  InputController,
  LineChart,
  TermGraph,
  Feed,
  CustomLineChart,
  CardOptions,
};
